import usePosOrderDeliveryMethod from "@/shared/atoms/usePosOrderDeliveryMethodAtom";
import { useSetPosOrderTable } from "@/shared/atoms/usePosOrderTable";
import useRestaurantMap from "@/shared/queries/restaurantMap/useRestaurantMap";
import useRestaurantMaps from "@/shared/queries/restaurantMap/useRestaurantMaps";
import { asArray } from "@/shared/utils/helpers";
import { RestaurantTable } from "@/shared/utils/interfaces";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "../Button/Button";
import Modal, { ModalProps } from "../Modal/Modal";
import Select from "../Select/Select";
import Spinner from "../Spinner/Spinner";

const PosTableModal = ({ onExit, ...props }: ModalProps) => {
  const [mapId, setMap] = useState(undefined);
  const { data: maps } = useRestaurantMaps();
  const chosenMap = useMemo(
    () => asArray(maps)?.find((option) => option.item_id === mapId),
    [mapId, maps]
  );
  const { data: map, isPending } = useRestaurantMap(mapId, mapId !== undefined);
  const [table, setTable] = useState<RestaurantTable>(undefined);
  const { t } = useTranslation("");
  const [_, setDeliveryMethod] = usePosOrderDeliveryMethod();
  const setPosTable = useSetPosOrderTable();
  const onSave = () => {
    setDeliveryMethod(3);
    setPosTable(table);
    onExit();
  };
  return (
    <Modal width={"58rem"} onExit={onExit} {...props}>
      <h1>{t("chooseMapAndTable")}</h1>
      <div className="mb-[2rem]">
        <Select
          menuPlacement="bottom"
          styles={{
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999,
            }),
          }}
          menuPortalTarget={document.getElementById("root")}
          options={maps ?? []}
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.item_id}
          label={t("chooseUrMap")}
          value={chosenMap}
          onChange={(e) => {
            setMap(e.item_id);
            setTable(undefined);
          }}
        />
      </div>
      {mapId ? (
        <div className="mb-[2rem]">
          {isPending ? (
            <Spinner />
          ) : (
            <Select
              menuPlacement="top"
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
              }}
              menuPortalTarget={document.getElementById("root")}
              options={map.tables ?? []}
              getOptionLabel={(option: RestaurantTable) =>
                `${option.name} - ${option.table_number} `
              }
              getOptionValue={(option) => option.item_id}
              label={t("chooseUrTable")}
              value={map?.tables.find((t) => t.item_id === table.item_id)}
              onChange={(e) => {
                setTable(e);
              }}
            />
          )}
        </div>
      ) : null}
      <div className="flex gap-8">
        <Button onClick={onSave} isDisabled={table === undefined}>
          {t("save")}
        </Button>
        <Button onClick={() => onExit()}>{t("close")}</Button>
      </div>
    </Modal>
  );
};

export default PosTableModal;
